// extracted by mini-css-extract-plugin
export var container = "_2e-0";
export var disabled = "_2e-4";
export var fullWidth = "_2e-3";
export var lined = "_2e-1";
export var selected = "_2e-5";
export var tab = "_2e-2";